import CardSystem from '../../Card/CardSystem';
import { UIEvent } from 'System/UI/BaseUISystem';
import { StartAnimationClip } from 'System/Animation/AnimationHelper';
import TransformComponent from 'Component/Transform';
import { DragonbonesDefault, DragonbonesFadeIn } from 'System/Animation/Clip';
import Point from 'Utility/Point';
import AnimationClip from 'System/Animation/AnimationClip';
import BaseCard from 'Prototype/Level/Card/BaseCard';
import Renderable from 'Component/Renderable';
import Interactable from 'Component/Interactable';
import CardComponent from 'Component/Level/Card';
import Animator from 'Prototype/Animator';
import { MainAnim } from './MainAnim';
import { Easing, Interpolation } from '@tweenjs/tween.js';
import { delay } from 'Utility/Task/TaskQueue';

interface IRevealCanisterPreBoosterMeta {
    system: CardSystem;
    card: BaseCard;
    cardId: string;
}

export class RevealCanisterPreBooster extends AnimationClip<IRevealCanisterPreBoosterMeta> {
    public *execute(animator: Animator, meta: IRevealCanisterPreBoosterMeta): IterableIterator<number> {
        const { system, card, cardId } = meta;

        const armature = card.getArmature();
        const animatorTransform = animator.getComponent(TransformComponent);
        const cardInteractable = card.getComponent(Interactable);
        const armatureRenderable = armature.getComponent(Renderable);
        armatureRenderable.alpha = 0;

        const center = new Point(animatorTransform.width / 2, animatorTransform.height / 2);

        const cardTransform = card.getComponent(TransformComponent);
        animator.addChild(card);
        cardTransform.position.set(center.x, center.y);

        card.getComponent(Renderable).visible = true;
        cardInteractable.enabled = false;
        cardInteractable.buttonMode = false;
        card.getComponent(CardComponent).animating = true;

        StartAnimationClip(
            new DragonbonesFadeIn(armature, {
                playTimes: 1,
                animationName: 'start',
                concat: false,
            })
        );

        yield* delay(2000);

        StartAnimationClip(
            new MainAnim(
                armature,
                {
                    scaleX: 0.42,
                    scaleY: 0.42,
                    duration: 600,
                    easing: Easing.Sinusoidal.Out,
                    interpolation: Interpolation.Bezier,
                },
                true
            )
        );

        system.stackContainer.addChild(card);
        system.cardStack.update();
        card.getComponent(Interactable).buttonMode = true;

        yield* delay(600);

        StartAnimationClip(
            new DragonbonesDefault(armature, {
                animationName: 'idle',
                playTimes: Infinity,
            })
        );

        system.scene.emit(UIEvent.RESTORE_INTERACTIVITY, true);
    }
}
